var React = require('react');

function IconPill (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.39352 25.6066C2.05037 23.2634 2.05037 19.4645 4.39352 17.1213L10.7575 10.7574L19.2428 19.2426L12.8788 25.6066C10.5357 27.9497 6.73667 27.9497 4.39352 25.6066V25.6066Z","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.7573 10.7574L17.1213 4.39339C19.4644 2.05025 23.2634 2.05025 25.6066 4.39339V4.39339C27.9497 6.73654 27.9497 10.5355 25.6066 12.8787L19.2426 19.2426L10.7573 10.7574Z","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconPill.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = IconPill;

IconPill.default = IconPill;
